import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

export const FAQ_ITEMS = [
  {
    q: "What exactly is included in Business in a Box?",
    a: "Everything a research peptide brand needs to launch: wholesale peptide supply, white-label vials and packaging with your branding, a logo and full brand identity, a custom storefront with checkout, 3PL fulfillment setup, and compliance documents — delivered as one project for $9,997.",
  },
  {
    q: "Do I need to buy or store inventory?",
    a: "You buy inventory at wholesale when you're ready — the first-order minimum is set with the supplier — and you own it. You never store it yourself: 3PL partners hold your stock and pick, pack, and ship every order. Storage and fulfillment fees are billed as you sell, and per-order shipping is paid by you or your buyers.",
  },
  {
    q: "Are the peptides for human use?",
    a: "No. Products are positioned strictly as research-use-only (RUO). Our compliance framework keeps your labels, documentation, and website copy within research-use marketing norms — that's built into every package. (This is operational guidance, not legal advice.)",
  },
  {
    q: "How long does it take to launch?",
    a: "A standalone storefront goes live in about two to three weeks. The full Business in a Box — supply, vials, brand, site, and fulfillment — runs about four to six weeks on one scheduled timeline. You'll watch every deliverable move on your own dashboard as it happens.",
  },
  {
    q: "What does it cost?",
    a: "Business in a Box is $9,997 and covers the complete setup. Website Creation is $4,997 if you only need the storefront. The Launch Checklist builds a tailored proposal from exactly what you need, so you can see pricing before committing.",
  },
  {
    q: "Can you work with a supplier I already have?",
    a: "Yes. If you already have wholesale supply, we can build the brand, white-label packaging, storefront, and fulfillment around your existing relationship — the pieces are designed to fit together either way.",
  },
  {
    q: "What support do I get after launch?",
    a: "Ongoing compliance updates as research-use requirements evolve, technical support over email, and periodic growth check-ins about optimization and what to build next.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
    <div className="mx-auto w-full max-w-3xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow testId="faq-eyebrow">Questions</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-paper sm:text-4xl">
          Asked before every launch.
        </h2>
        <p className="mt-4 max-w-md text-base text-paper/60">
          Straight answers on what's included, how RUO positioning works, and what launching actually looks like.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-white/[0.08]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="py-5 text-left font-display text-base font-extrabold text-paper transition-colors hover:text-lilac hover:no-underline sm:text-lg"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-answer-${i}`}
                className="pb-5 text-sm leading-relaxed text-paper/60 sm:text-base"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
